import { Navigate } from "react-router";
import { useGetShipmentHistoryQuery } from "../../../apis/ShipmentHistory.api";
import { PrimaryShipmentHistory, ShipmentHistory } from "../../../types/models/ShipmentHistory";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const ShipmentHistoryScoped = () => {
    const {
        data,
    } = useGetShipmentHistoryQuery(PrimaryShipmentHistory.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/shipment-histories/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default ShipmentHistoryScoped;
